import { de } from "date-fns/locale";

export const ssoUrl = `${process.env.REACT_APP_SSO_OPENAPIPAAS_URL}`;
const resourceDomain = localStorage.getItem("resourceDomain");
const getEnvVariable = (key) => process.env[key];

// Firebase.js (Integrated)
// import firebase from 'firebase';
const firebaseConfig = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
  authDomain: `${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`,
  projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
  storageBucket: `${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`,
  messagingSenderId: `${process.env.REACT_APP_FIREBASE_MESSAGING_SENDING_ID}`,
  appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`
};
// Initialize Firebase
// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

let urls = {
  baseUrl: getEnvVariable(
    `REACT_APP_BASE_${resourceDomain?.toUpperCase()}_STAGING_URL`
  ),
  prodUrl: getEnvVariable(
    `REACT_APP_BASE_${resourceDomain?.toUpperCase()}_PRODUCTION_URL`
  ),
  sandboxUrl: getEnvVariable(
    `REACT_APP_BASE_${resourceDomain?.toUpperCase()}_SANDBOX_URL`
  ),
  resourceOwnerUrl: getEnvVariable(
    `REACT_APP_RESOURCE_${resourceDomain?.toUpperCase()}_URL`
  ),
};

let environmentUrls = {
  Staging: urls.baseUrl,
  Sandbox: urls.sandboxUrl,
  Production: urls.prodUrl,
};

let commonConfigs = {
  firebaseConfig,
  ssoHeader: {
    "api-key": getEnvVariable(
      `REACT_APP_SSO_${resourceDomain?.toUpperCase()}_API_KEY`
    ),
    "project-id": getEnvVariable(
      `REACT_APP_SSO_${resourceDomain?.toUpperCase()}_PROJECT_ID`
    ),
    "platform-syscode": process.env.REACT_APP_PLATFORM_SYSCODE,
  },
  apiHeader: {
    "api-key": getEnvVariable(
      `REACT_APP_DEVELOPER_${resourceDomain?.toUpperCase()}_STAGING_API_KEY`
    ),
    "project-id": getEnvVariable(
      `REACT_APP_DEVELOPER_${resourceDomain?.toUpperCase()}_STAGING_PROJECT_ID`
    ),
    "platform-syscode": process.env.REACT_APP_PLATFORM_SYSCODE,
  },
  sandboxApiHeader: {
    "api-key": getEnvVariable(
      `REACT_APP_DEVELOPER_${resourceDomain?.toUpperCase()}_SANDBOX_API_KEY`
    ),
    "project-id": getEnvVariable(
      `REACT_APP_DEVELOPER_${resourceDomain?.toUpperCase()}_SANDBOX_PROJECT_ID`
    ),
    "platform-syscode": process.env.REACT_APP_PLATFORM_SYSCODE,
  },
  prodApiHeader: {
    "api-key": getEnvVariable(
      `REACT_APP_DEVELOPER_${resourceDomain?.toUpperCase()}_PRODUCTION_API_KEY`
    ),
    "project-id": getEnvVariable(
      `REACT_APP_DEVELOPER_${resourceDomain?.toUpperCase()}_PRODUCTION_PROJECT_ID`
    ),
    "platform-syscode": process.env.REACT_APP_PLATFORM_SYSCODE,
  },
  resourceOwnerApiHeader: {
    "api-key": getEnvVariable(
      `REACT_APP_RESOURCE_${resourceDomain?.toUpperCase()}_API_KEY`
    ),
    "project-id": getEnvVariable(
      `REACT_APP_RESOURCE_${resourceDomain?.toUpperCase()}_PROJECT_ID`
    ),
    "platform-syscode": process.env.REACT_APP_PLATFORM_SYSCODE,
  },

  apiUrls: {
    ssoUserAuth: () => `${ssoUrl}/auth/users`,
    ssoAdminAuth: () => `${ssoUrl}/auth/business`,
    login: () => `/web/auth/login`,
    refreshAccessToken: () => `/web/auth/token/refresh`,

    //Staging Developer Projects Apis
    GetAllDeveloperProjects: (developer_sso_id, developer_proj_table_syscode) =>
      `/developers/${developer_sso_id}/projects?developer_proj_table_syscode=${developer_proj_table_syscode}`,
    GetOneDeveloperProjects: (developer_sso_id, developer_proj_id, developer_proj_table_syscode) =>
      `/developers/${developer_sso_id}/projects/${developer_proj_id}?developer_proj_table_syscode=${developer_proj_table_syscode}`,
    CreateDeveloperProject: (developer_proj_table_syscode) => `/developers/projects?developer_proj_table_syscode=${developer_proj_table_syscode}`,
    doublewriteDeveloperProject: (developer_proj_table_syscode) => `/developers/projects/doublewrite?developer_proj_table_syscode=${developer_proj_table_syscode}`,
    UpdateDeveloperProject: (developer_proj_id, developer_proj_table_syscode) =>
      `/developers/projects/${developer_proj_id}?developer_proj_table_syscode=${developer_proj_table_syscode}`,
    adminGetAllDeveloperProjects: (developer_proj_table_syscode, page) => `/developers/projects?developer_proj_table_syscode=${developer_proj_table_syscode}`,
    getProjects: () => `/resource-group/projects`,
    getDeveloperProjectByPlan: (developer_sso_id, org_invoice_plan_id) =>
      `/developers/${developer_sso_id}/projects?org_invoice_plan_id=${org_invoice_plan_id}`,
    getValidateProjects: (developer_sso_id, certificate_syscode) =>
      `/developers/${developer_sso_id}/projects?certificate_syscode=${certificate_syscode}`,

    //Portfolio Apis
    getAllPortfolioProjects: (mobileNum) =>
      `/developers/portfolios/mobile/${mobileNum}`,

    // Access Pages Apis
    getAllAccessPages: () => `/developers/access`,
    createAccessPage: () => `/developers/access`,
    updateAccessPage: (access_id) => `/developers/access/${access_id}`,
    deleteAccessPage: (access_id) => `/developers/access/${access_id}`,

    getVoucher: (voucher_code) =>
      `/common/org/${process.env.REACT_APP_RESOURCE_OPENAPIPAAS_ORG_ID}/vouchers?code=${voucher_code}`,

    validateVoucher: (
      account_id,
      voucher_code,
      org_invoice_plan_id
    ) =>
      `/common/org/${process.env.REACT_APP_RESOURCE_OPENAPIPAAS_ORG_ID}/vouchers/developers/${account_id}?voucher_code=${voucher_code}&org_invoice_plan_id=${org_invoice_plan_id}`,

    getCertificationPlans: () => `/developers/plans/certifications`,
    getProductionPlans: () => `/developers/plans/production`,
    getStagingPlans: () => `/developers/plans/staging`,

    getAllDeveloperCertificates: (account_id) =>
      `/developers/certifications/${account_id}`,

    validateNetsQrTxn: (retrieval_ref, txn_id, platform_syscode) =>
      `/developers/certifications/nets-qr?txn_retrieval_ref[]=${retrieval_ref}&txn_id[]=${txn_id}&platform_syscode=${platform_syscode}`,

    validateNetsClickTxn: (retrieval_ref, txn_id, platform_syscode) =>
      `/developers/certifications/nets-click?txn_retrieval_ref[]=${retrieval_ref}&txn_id[]=${txn_id}&platform_syscode=${platform_syscode}`,

    validateEnetsTxn: (retrieval_ref, txn_id, platform_syscode) =>
      `/developers/certifications/enets?txn_retrieval_ref[]=${retrieval_ref}&txn_id[]=${txn_id}&platform_syscode=${platform_syscode}`,

    createInvoice: () => `/transactions/invoices`,
    updateInvoice: (txn_invoice_id) => `/transactions/invoices/${txn_invoice_id}/status`,

    getInvoices: (
      account_id,
      invoice_syscode,
      invoice_start_date,
      invoice_end_date,
      invoice_status,
      developer_proj_id,
      project_id
    ) =>
      `/transactions/invoices?account_id=${account_id}&invoice_syscode=${invoice_syscode}&invoice_start_date=${invoice_start_date}&invoice_end_date=${invoice_end_date}&invoice_status=${invoice_status}&developer_proj_id=${developer_proj_id}&project_id=${project_id}`,
    createDeveloperCourse: (account_id) => `/developers/${account_id}/courses`,
    getDeveloperCourses: (account_id, org_invoice_plan_id, is_expired) =>
      `/developers/${account_id}/courses?org_invoice_plan_id=${org_invoice_plan_id}&is_expired=${is_expired}`,

    requestNetsApi: () => `/common/payments/nets-qr/request`,
    queryNetsApi: () => `/common/payments/nets-qr/query`,
    webhookNetsApi: (txnRetrievalRef) =>
      `/common/payments/nets/webhook?txn_retrieval_ref=${txnRetrievalRef}`,

    createCertificate: () => `/developers/certifications`,

    updateCertificate: () => `/developers/certifications`,

    // Access Roles Apis
    getAllAccessRoles: () => `/developers/roles`,
    createAccessRole: () => `/developers/roles`,
    updateAccessRole: (role_id) => `/developers/roles/${role_id}`,
    deleteAccessRole: (role_id) => `/developers/roles/${role_id}`,

    // Certification API
    getAllStudentCertificationDetails: (start_date, end_date, certificate_syscode, developer_certification_status, training_provider_id, page, search_term) =>
      `/developers/certifications?start_date=${start_date}&end_date=${end_date}&certificate_syscode=${certificate_syscode}&developer_certification_status=${developer_certification_status}&training_provider_id=${training_provider_id}&page=${page}&search_term=${search_term}`,

    getCertificateTemplates: (certificate_syscode, training_provider_id, certificate_proficiency_syscode) => 
      `/developers/certifications/certificates?certificate_syscode=${certificate_syscode}&training_provider_id=${training_provider_id}&certificate_proficiency_syscode=${certificate_proficiency_syscode}`,

    getCertificatePdf: (developer_certificate_id) =>
      `/developers/certifications/certificates?developer_certificate_id=${developer_certificate_id}`,

    // Certificate Templates Apis
    getAllCertificateTemplates: (training_provider_id, certificate_syscode, certificate_proficiency_syscode, page, search_term) =>
      `/developers/certifications/certificates/templates?training_provider_id=${training_provider_id}&certificate_syscode=${certificate_syscode}&certificate_proficiency_syscode=${certificate_proficiency_syscode}&page=${page}&search_term=${search_term}`,
    createCertificateTemplate: () => `/developers/certifications/certificates/templates`,
    updateCertificateTemplate: (certificate_id) => `/developers/certifications/certificates/${certificate_id}/templates`,
    deleteCertificateTemplate: (certificate_id) => `/developers/certifications/certificates/${certificate_id}/templates`,

    // Administrators Apis
    getAllAdministrators: () => `/developers/administrators`,
    createAdministrator: () => `/developers/administrators`,
    updateAdministrator: (account_id) => `/developers/administrators/${account_id}`,
    deleteAdministrator: (account_id) => `/developers/administrators/${account_id}`,

    // Configurations Apis
    // GetAllBillingConfig: () =>
    //   `${beveatUrl}/resource-groups/projects/billing-config`,
    // // `http://localhost:8080/api/v1/resource-groups/projects/billing-config`,
    // GetOneBillingConfig: (billing_config_id) =>
    //   `${beveatUrl}/resource-groups/projects/billing-config/${billing_config_id}`,
    // CreateBillingConfig: () =>
    //   `${beveatUrl}/resource-groups/projects/billing-config`,
    // UpdateBillingConfig: (billing_config_id) =>
    //   `${beveatUrl}/resource-groups/projects/billing-config/${billing_config_id}`,
    // DeleteBillingConfig: (billing_config_id) =>
    //   `${beveatUrl}/resource-groups/projects/billing-config/${billing_config_id}`,

    // GetAllSubscriptionPlan: () => `${beveatUrl}/resource-groups/subscriptions`,
    // // `http://localhost:8080/api/v1/resource-groups/subscriptions`,
    // GetOneSubscriptionPlan: (subscription_id) =>
    //   `${beveatUrl}/resource-groups/subscriptions/${subscription_id}`,
    // CreateSubscriptionPlan: () => `${beveatUrl}/resource-groups/subscriptions`,
    // UpdateSubscriptionPlan: (subscription_id) =>
    //   `${beveatUrl}/resource-groups/subscriptions/${subscription_id}`,
    // DeleteSubscriptionPlan: (subscription_id) =>
    //   `${beveatUrl}/resource-groups/subscriptions/${subscription_id}`,
  },
};

let environmentHeaders = {
  Staging: commonConfigs.apiHeader,
  Sandbox: commonConfigs.sandboxApiHeader,
  Production: commonConfigs.prodApiHeader,
};

// Doublewrite Config Function
export function doublewriteConfig(currentEnv) {
  const configs = {
    production: {
      url: process.env.REACT_APP_BASE_OPENAPIPAAS_STAGING_URL,
      headers: {
        "api-key": process.env.REACT_APP_DEVELOPER_OPENAPIPAAS_STAGING_API_KEY,
        "project-id": process.env.REACT_APP_DEVELOPER_OPENAPIPAAS_STAGING_PROJECT_ID,
        "platform-syscode": process.env.REACT_APP_PLATFORM_SYSCODE
      },
    },
    staging: {
      url: process.env.REACT_APP_BASE_OPENAPIPAAS_SANDBOX_URL,
      headers: {
        "api-key": process.env.REACT_APP_DEVELOPER_OPENAPIPAAS_SANDBOX_API_KEY,
        "project-id": process.env.REACT_APP_DEVELOPER_OPENAPIPAAS_SANDBOX_PROJECT_ID,
        "platform-syscode": process.env.REACT_APP_PLATFORM_SYSCODE
      },
    },
  };

  return configs[currentEnv] || {};
}

export { urls, environmentUrls, commonConfigs, environmentHeaders, firebaseConfig };